import React from 'react'
import { observer } from 'mobx-react';
import {FiTarget} from 'react-icons/fi'
import {FaRegCalendarAlt} from 'react-icons/fa'

import {store} from '../../stores/store'

import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import AleasPool from '../../js/AleasPool';
import { GAME_STATES } from '../../js/ids';

function TopLeftUI() {

  const goalsOpened = PopupStore.isOpened(POPUPS_IDS.GOALS)
  const aleasOpened = PopupStore.isOpened(POPUPS_IDS.ALEAS)
  let zIndex = goalsOpened || aleasOpened ? 1 : 0

  function handleYearClick() {
    // PopupStore.open(POPUPS_IDS.GAME_OVER)

  }

  function handleGoalsClick() {
    if(store.gameState === GAME_STATES.INGAME) {
      PopupStore.toggle(POPUPS_IDS.GOALS)
    }

    if(store.gameState === GAME_STATES.OVER_DEFEAT || store.gameState === GAME_STATES.OVER_VICTORY) {
      PopupStore.toggle(POPUPS_IDS.GAME_OVER)
    }
  }
  return (

    <div className="top-left-ui" style={{zIndex}}>
      <div className="ui-button ui-button-left ui-button-top">
        <span className="label" onClick={handleYearClick}>{store.t("year")} {store.yearNumber}</span>
        <div className="separator" />

        <span
        className={"icon" + (goalsOpened ? " selected" : "")}
        onClick={handleGoalsClick} >
          <FiTarget />
        </span>

        <span
        className={"icon" + (aleasOpened ? " selected" : "")}
        onClick={() => {PopupStore.toggle(POPUPS_IDS.ALEAS)} } >
          {AleasPool.notif && <div className="notif">!</div>}
          <FaRegCalendarAlt />
        </span>
      </div>
    </div>
  )
}

export default observer(TopLeftUI)